import React from "react";
import { useAuth } from "react-oidc-context";
import "../styles/Topbar.css";

const Topbar = () => {
  const auth = useAuth();

  const rawUserName =
    auth.user?.profile?.["cognito:username"] ||
    auth.user?.profile?.email ||
    "Usuario";

  const userName =
    rawUserName.charAt(0).toUpperCase() + rawUserName.slice(1);

  return (
    <div className="topbar">
      <p>¡Bienvenido, {userName}!</p>
    </div>
  );
};

export default Topbar;
